import { render, staticRenderFns } from "./editJuryEdition.vue?vue&type=template&id=280394b6"
import script from "./editJuryEdition.vue?vue&type=script&lang=js"
export * from "./editJuryEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports